<template>
    <i class="fa fa-comment" :style="{opacity: ad.dtp_comment ? 1 : 0.2}" v-tooltip="ad.dtp_comment"></i>
</template>

<script>
    export default {
        props: {
            ad: {
                type: Object,
                required: true
            }
        }
    }
</script>
